import React from 'react';
import PropTypes from 'prop-types';
import setClass from '../../common/set-class';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './empty-beehive.svg' or its co... Remove this comment to see the full error message
import EmptyBeehive from './empty-beehive.svg';
const NoContent = ({ header, text, className }) => (React.createElement("div", { className: setClass('b-no-data', className) },
    React.createElement("img", { src: EmptyBeehive, className: "b-no-data__img", alt: "No content" }),
    React.createElement("div", { className: "b-no-data__header" },
        " ",
        header,
        " "),
    React.createElement("div", { className: "b-no-data__text" },
        " ",
        text,
        " ")));
NoContent.propTypes = {
    header: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
};
NoContent.defaultProps = {
    header: 'No results found',
    text: 'We couldn’t find a match. Try changing the filter, or search with a different keyword.',
    className: undefined,
};
export default NoContent;
